<template>
  <div class="between_item between_right">
    <card title="监控视频" v-show="!isStartCheck">
      <div class="card_video box_style">
        <div class="item_list" v-if="videoListData.length > 0">
          <div class="item fs" v-for="(item, index) in videoListData" :key="index">
            <div class="xg_flv_check"></div>
          </div>
        </div>
        <div class="item_list" v-else>
          <div class="item fs item_loading">
            <p>视频流加载中</p>
          </div>
          <div class="item fs item_loading">
            <p>视频流加载中</p>
          </div>
        </div>
      </div>
      <!-- <div class="card_chart box_style">
        <p class="title">巡检问题统计</p>
        <div class="content fb">
          <div class="chart_box" id="checkChartBox2"></div>
          <div class="line"></div>
          <div class="info">
            <p class="light">5080</p>
            <p>问题总数(件)</p>
          </div>
        </div>
      </div> -->
    </card>
    <card title="巡检数据" v-show="isStartCheck">
      <div class="card_table check_table" id="cardTable">
        <!-- <el-table
          :data="curSmartCheckData"
          ref="tableRef"
          :row-class-name="tableRowClassName"
          highlight-current-row
          height="420"
        >
          <el-table-column prop="dianya" label="系统电压" align="center"> </el-table-column>
          <el-table-column prop="pinlv" label="系统频率" align="center"> </el-table-column>
          <el-table-column prop="dianliu" label="励磁电流" align="center"> </el-table-column>
          <el-table-column prop="status" label="机组状态" align="center"> </el-table-column>
          <el-table-column prop="time" label="时间" align="center"> </el-table-column>
        </el-table> -->
        <div class="card_detail box_style" v-if="curCheckData">
          <div class="detail_list">
            <div class="list_title">
              <p class="light">
                {{ curCheckData.objName ? `${curCheckData.objName}` : '正在前往巡检点' }}
              </p>
            </div>
            <div class="list_item fs" v-for="(item, index) in curCheckData.projects" :key="index">
              <!-- <div class="icon">
                <img class="Img" :src="`${require(`@/assets/hs/icon_6_1.png`)}`" alt="" />
              </div> -->
              <div class="info_list" v-for="(pro, proIndex) in item.contents" :key="proIndex">
                <div class="item_text">
                  <p class="name">{{ pro.name.substring(6) }} ：</p>
                  <p class="value">{{ pro.checkVal || '正常' }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </card>
    <card title="机器人视角" styles="margin-top:5px" v-show="!isStartCheck">
      <div class="card_video_robot box_style">
        <div class="view_box">
          <div class="xg_flv_robot" id="xgFlvRobot" v-if="videoListData.length > 0"></div>
          <div class="item_loading" v-else>
            <p>视频流加载中</p>
          </div>
        </div>
      </div>
    </card>
    <card title="巡检画面" styles="margin-top:24px" v-show="isStartCheck">
      <div class="card_video_robot card_video_robot_view box_style">
        <!-- <div class="view_box"> -->
        <!-- <img
            src="http://172.30.100.201/subapp/huoshan-gis-platform/static/img/3.cbaa0b57.jpg"
            alt=""
            class="Img"
            style="width: 100%"
          /> -->
        <div class="xg_flv_robot" id="xgFlvRobotView"></div>
        <!-- </div> -->
      </div>
    </card>
  </div>
</template>

<script>
import Card from '@/components/Card.vue';
import Player from 'xgplayer';
import FlvPlugin from 'xgplayer-flv';
import { BASE_IP_URL } from '@/globalConfig';

import * as Api from '@/api';

export default {
  components: {
    Card,
  },
  data() {
    return {
      videoListData: [],
      videoRobot: null,
      echartsOpt: {
        tooltip: {
          trigger: 'item',
        },
        legend: {
          orient: 'horizontal',
          left: 'left',
          textStyle: {
            color: '#99BCD6',
          },
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: '50%',
            data: [
              { value: 34, name: '未完成', itemStyle: { color: '#4F87F6' } },
              { value: 66, name: '已完成', itemStyle: { color: '#54E3F7' } },
            ],
            label: {
              show: true,
              color: '#99BCD6',
              formatter(param) {
                // correct the percentage
                return param.name + ' (' + param.percent + '%)';
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 1)',
              },
            },
          },
        ],
      },
      tableConfig: {
        header: ['任务名称', '任务类型', '时间', '操作'],
        rowNum: 5,
        // waitTime: 60000,
        data: [],
        headerBGC: 'rgba(3,74,144,0.3)',
        columnWidth: [150, 150, 150, 150],
        align: ['center', 'center', 'center', 'center'],
        oddRowBGC: 'rgba(14,36,60,0.4)',
        evenRowBGC: 'rgba(14,36,60,0.8)',
      },
      isStartCheck: false,
      curSmartCheckData: [
        {
          dianya: '403.3V',
          pinlv: '50.01Hz',
          dianliu: '0.0A',
          status: '正常',
          time: '2023.10.15 11:55:20',
        },
        {
          dianya: '403.3V',
          pinlv: '50.01Hz',
          dianliu: '0.0A',
          status: '正常',
          time: '2023.10.15 16:55:20',
        },
        {
          dianya: '403.3V',
          pinlv: '50.01Hz',
          dianliu: '0.0A',
          status: '正常',
          time: '2023.10.15 20:55:20',
        },
        {
          dianya: '403.3V',
          pinlv: '50.01Hz',
          dianliu: '0.0A',
          status: '正常',
          time: '2023.10.15 24:55:20',
        },
      ],
      curCheckData: {
        //checkPoint: '正在前往巡检点', //巡检点名称
        // checkState: '正常', //检查的状态
        // checkInfo: [
        //   { code: '', name: '线电压Uab', value: '376.6V' }, //---4
        //   { code: '', name: '系统电压', value: '380.1V' }, //---1
        //   { code: '', name: '系统频率', value: '50.01Hz' },
        // ],
      },
      curCheckInfoList: [],
    };
  },
  mounted() {
    this.renderTable();
    this.renderChart();
    this.$bus.$on('isStartCheck', (data) => {
      this.isStartCheck = data;
      if (!data) {
        this.curCheckData = {};
      }
    });
    this.$bus.$on('curCheckInfo', (data) => {
      console.log(data);
      this.curCheckData = data;
    });
    this.$bus.$on('curCheckInfoList', (data) => {
      this.curCheckInfoList = data;
      console.log('curCheckInfoList :>> ', data);
    });
  },
  methods: {
    renderTable() {
      this.getVideoList();
      this.getReplayVideo();
      const tableData = [];
      for (let i = 0; i < 50; i++) {
        tableData.push([
          `设备${i}`,
          `设备${i}故障`,
          `2022-08-12`,
          `<span class="type2">回放</span>`,
        ]);
      }
      this.tableConfig['data'] = tableData;
    },
    renderChart() {
      // let myChart = this.$echarts.init(document.getElementById('checkChartBox2'));
      // myChart.setOption(this.echartsOpt);
    },
    clickCheckReview() {
      this.$Model.i3dStartLineCheck();
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    // 获取回放视频
    getReplayVideo() {
      // Api.getReplayVideo().then((res) => {
      //   console.log('resshiphuifang :>> ', res);
      //   if (res.success) {

      this.$nextTick(() => {
        var playerRobot = new Player({
          id: 'xgFlvRobotView',
          loop: true,
          playbackRate: [1, 2, 3, 4, 5, 6],
          // el: videoEl[i],
          // url: res.data.path,
          url: 'http://223.214.6.181:28000/prd200000/upload/20231107/93b2b684fb20e9c95b63f0dc3c2c9a40.mp4',
          // url: 'http://172.30.100.201:8000/prd200000/upload/20231107/93b2b684fb20e9c95b63f0dc3c2c9a40.mp4', //正式演示的时候切换成固定地址
          // url: 'http://172.30.100.204:8950/openUrl/QKmY036/playback.flv?beginTime=20231110T083348&endTime=20231110T084505.017', //正式演示的时候切换成固定地址
          playsinline: true,
          poster: 'http://172.30.100.201/subapp/huoshan-gis-platform/static/img/3.cbaa0b57.jpg',
          autoplay: true,
          width: 470,
          height: 300,
          plugins: [],
          // isLive: true,
        });
        const videoEl = document.querySelector('#xgFlvRobotView video');
        console.log(videoEl);
      });
      //   }
      // });
    },

    // 获取智能巡检右侧两个实时视频
    getVideoList() {
      // Api.getFlvListEscape({ stationId: '2000000134006' }).then((res) => {
      //   if (res.success) {
      //     const { data } = res;
      //     console.log('data :>> ', data);
      //     const robotVideo = data[data.length - 1];
      //     this.videoRobot = robotVideo.url;
      //     console.log('robotVideo.url :>> ', robotVideo.url);
      //     this.$nextTick(() => {
      //       var playerRobot = new Player({
      //         id: 'xgFlvRobot',
      //         // el: videoEl[i],
      //         url: robotVideo.url,
      //         playsinline: true,
      //         poster: 'http://172.30.100.201/subapp/huoshan-gis-platform/static/img/3.cbaa0b57.jpg',
      //         autoplay: true,
      //         width: 470,
      //         height: 220,
      //         plugins: [FlvPlugin],
      //         isLive: true,
      //       });
      //     });
      //   }
      // });
      Api.getHikFlvByStationCode().then((res) => {
        if (res.success) {
          const { records } = res.data;
          // this.videoListData.push(res[0], res[2]);
          this.videoListData.push(records[9], records[11], records[10]); //顺序变了就用这个
          this.renderVideoBox();
        }
      });
    },
    renderVideoBox() {
      this.$nextTick(() => {
        let videoEl = document.querySelectorAll('.xg_flv_check');
        let videoElRobot = document.querySelectorAll('.xg_flv_robot');
        console.log('videoEl :>> ', videoEl);
        for (let i = 0; i < 2; i++) {
          var player = new Player({
            // id: 'xgFlv',
            el: videoEl[i],
            url: this.videoListData[i].liveSourceAddress.replace(
              'http://223.214.6.181:8950/openUrl/',
              // '172.30.100.204:8950'
              BASE_IP_URL
            ),
            playsinline: true,
            poster: 'http://172.30.100.201/subapp/huoshan-gis-platform/static/img/2.20ed85c7.jpg',
            autoplay: true,
            width: 470,
            height: 220,
            plugins: [FlvPlugin],
            isLive: true,
          });
        }
        var playerRobot = new Player({
          // id: 'xgFlv',
          el: videoElRobot[0],
          url: this.videoListData[2].liveSourceAddress.replace(
            'http://223.214.6.181:8950/openUrl/',
            // '172.30.100.204:8950'
            BASE_IP_URL
          ),
          playsinline: true,
          poster: 'http://172.30.100.201/subapp/huoshan-gis-platform/static/img/2.20ed85c7.jpg',
          autoplay: true,
          width: 470,
          height: 220,
          plugins: [FlvPlugin],
          isLive: true,
        });
      });
    },
  },
  beforeDestroy() {
    this.$bus.$off('isStartCheck');
    this.$bus.$off('curCheckInfo');
    this.isStartCheck = false;
  },
};
</script>

<style lang="scss" scoped>
.card_video {
  height: 450px;
  // height: 198px;
  // padding: 0 9px;
  padding: 0;
  .item_list {
    flex-wrap: wrap;
    height: 100%;
    display: flex;
    align-content: space-around;
    .item {
      // width: 470px;
      // height: 190px;
      border: 1px solid rgba(79, 158, 253, 0.4);
      margin: auto;
      // margin-top: 12px;
      cursor: pointer;
      &.item_loading {
        width: 470px;
        height: 190px;
        p {
          margin: auto;
        }
      }
    }
  }
}
.card_chart {
  width: 480px;
  height: 196px;
  margin-top: 25px;
  padding: 10px 10px;
  .content {
    margin-top: 20px;
  }
  .line {
    width: 1px;
    height: 102px;
    opacity: 0.25;
    border: 1px solid;
    border-image: linear-gradient(
        180deg,
        rgba(13, 165, 251, 0.05),
        rgba(33, 61, 222, 0.5),
        rgba(140, 235, 255, 0.55),
        rgba(38, 68, 245, 0.46),
        rgba(13, 169, 254, 0.19)
      )
      1 1;
    margin: 0 3px;
  }
  .chart_box {
    width: 350px;
    height: 150px;
  }
  .info {
    width: 150px;
    height: 112px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 38px;
    padding-bottom: 20px;

    .light {
      font-size: 20px;
    }
  }
}
.card_table {
  width: 480px;
  height: 180px;
  &.check_table {
    height: 360px;
    overflow: auto;
  }
  // margin-top: 12px;
}
.card_chaijie {
  height: auto !important;
  min-height: 220px;
  .view_box {
    width: 470px;
    height: 220px;
    margin: 0 !important;
  }
}
.card_video_robot {
  width: 100%;
  min-height: 200px;
  display: flex;
  justify-content: center;
  .view_box {
    min-height: 190px;
    width: 100%;
    #xgFlvRobot {
      margin: auto;
    }
  }
  .item_loading {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .Img {
    height: 190px;
    object-fit: cover;
  }
}
.card_detail {
  padding: 12px 8px;
  .list_title {
    padding: 15px 0 20px 0;
    p {
      &.light {
        text-align: center;
        font-size: 20px;
      }
    }
  }
  .list_item {
    // align-items: flex-start;
    // margin-bottom: 10px;
    padding-left: 20px;
    align-items: end;
    flex-wrap: wrap;
    .info_list {
      display: flex;
    }
    .item_text {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 10px;
    }
    .icon {
      flex: 0 0 auto;
      width: 30px;
      // height: 20px;
      display: flex;
      align-items: center;
    }
    p {
      display: block;
      font-size: 20px;
    }
    .name {
      flex: 0 0 auto;
      width: 350px;
      margin-left: 8px;
      text-align: left;
    }
    .value {
      flex: 0 0 auto;
      // width: 380px;
      width: 50px;
      margin-left: 15px;
    }
  }
  .btn_box {
    width: 462px;
    margin-top: 13px;
    .btn {
      width: 228px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color: #fff;
      position: relative;
      cursor: pointer;
      &:nth-child(1) {
        background: linear-gradient(360deg, #ffea63 0%, rgba(192, 146, 43, 0.7) 100%);
      }
      &:nth-child(2) {
        background: linear-gradient(360deg, #56ade5 0%, rgba(45, 142, 216, 0.7) 100%);
      }
      &::before {
        content: '';
        position: absolute;
        top: -1px;
        left: -1px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 10px 10px 0 0;
        border-color: #092c51 transparent transparent transparent;
        transform: rotate(0deg);
      }
      &:active {
        opacity: 0.85;
      }
    }
  }
}
</style>
